import { render, staticRenderFns } from "./CreateClassDialog.vue?vue&type=template&id=066c0b64&scoped=true"
import script from "./CreateClassDialog.vue?vue&type=script&lang=js"
export * from "./CreateClassDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c0b64",
  null
  
)

export default component.exports